import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import IconButton from "@mui/material/IconButton";
import LogoutIcon from "@mui/icons-material/Logout";
import { Button, ListItem, Stack } from "@mui/material";

import useAuth from "../../hooks/useAuth";
import { allItemTop, userItems } from "../../constants/navbarList";
import {
  clearCrispSessionCache,
  openTicketCenterInNewTab,
} from "../../hooks/useCrispSession";

const TopNavBar = ({ handleDrawerToggle }) => {
  const { user } = useAuth();
  const [anchorEl, setAnchorEl] = useState(null);
  const [openIndex, setOpenIndex] = useState(null);
  const nav = useNavigate();

  const items = user.admin ? allItemTop : userItems;

  const [listItemTop, setListItemTop] = useState([
    ...(user.admin
      ? [
          {
            text: "Support",
            hasNoLink: true,
            onclick: () => {
              openTicketCenterInNewTab().catch(() => {
                window.alert("Unable to open support.");
              });
            },
          },
        ]
      : []),
    ...items,
    {
      text: "Logout",
      to: "/login",
      icon: <LogoutIcon />,
      hasNoLink: true,
      onclick: () => {
        clearCrispSessionCache();
        localStorage.clear();
        nav("/login");
      },
    },
  ]);

  const handleClick = (e, index) => {
    setOpenIndex(index);
    setAnchorEl(e.currentTarget);
  };
  const handleClose = (index) => {
    setOpenIndex(null);
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        color="inherit"
        aria-label="open drawer"
        edge="start"
        onClick={handleDrawerToggle}
        sx={{ mr: 2, display: { sm: "none" } }}
      >
        <MenuIcon />
      </IconButton>
      <Stack
        direction="row"
        spacing={2}
        sx={{ mr: 2, display: { xs: "none", sm: "flex" } }}
      >
        {listItemTop.map((list, index) =>
          list.subMenu && list.subMenu.length ? (
            <div key={`Button${list.text}`}>
              <Button
                color="inherit"
                key={`Button${list.text}`}
                id={`basic-button-${index}`}
                aria-controls={index === openIndex ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={index === openIndex ? "true" : undefined}
                onClick={(e) => handleClick(e, index)}
              >
                {list.text}
              </Button>
              <Menu
                id={`basic-menu-${index}`}
                key={`Menu${list.text}`}
                open={index === openIndex}
                onClose={() => handleClose(index)}
                anchorEl={anchorEl}
              >
                {list.subMenu.map((eachSubMenu) => (
                  <ListItem
                    button
                    component={Link}
                    to={`${list.to}/${eachSubMenu.to}`}
                    key={`${list.to}/${eachSubMenu.to}`}
                  >
                    {eachSubMenu.text}
                  </ListItem>
                ))}
              </Menu>
            </div>
          ) : (
            <Button
              color="inherit"
              key={list.text}
              to={list.to}
              onClick={list?.onclick ? list?.onclick : () => nav(list.to)}
            >
              {list.text}
            </Button>
          )
        )}
      </Stack>
    </>
  );
};

export default TopNavBar;
